import {
  SIDE_NAV_LIGHT,
  NAV_TYPE_SIDE,
  DIR_LTR,
} from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";

// The theme chosen last time on this device (QA UI-07: it was lost on every reload).
const savedTheme = () => {
  try {
    const t = localStorage.getItem("theme_key"); // THEME_KEY in constants/AuthConstant (not imported: it imports lang, which imports this file)
    return t === "dark" || t === "light" ? t : "light";
  } catch (e) {
    return "light";
  }
};
export const APP_NAME = "SEMMAPP";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const REDIRECT_URL_KEY = "redirect";
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/Welcome`;
export const NOT_FOUND_ENTRY = `${APP_PREFIX_PATH}/not-found`;
export const COMING_SOON_ENTRY = `${APP_PREFIX_PATH}/coming-soon`;
export const UNAUTHENTICATED_ENTRY = "/login";
export const THEME_CONFIG = {
  navCollapsed: false,
  sideNavTheme: SIDE_NAV_LIGHT,
  locale: "en",
  navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: savedTheme(),
  direction: DIR_LTR,
  blankLayout: false,
};
